import { postAction, getAction } from './manage';

export function getBusinessGroup() {
    return new Promise((resolve, reject) => {
        getAction('/sys/sysDepart/queryBusinessGroupList',{applicationCode:'prevent'})
        .then(res => {
            if(res.success){
                console.log(res)
                resolve(res.result.map(i => {return {label: i.departName, value: i.orgCode}}));
            } else {
                resolve([])
            }
        })
        .catch(e => {
            resolve([]);
        });
    })
}

export function getBusinessUnitByIds(idList){
    return new Promise((resolve, reject) => {
        postAction('/sys/sysDepart/getBusinessUnitListByPids', idList).then(res=>{
            if(res.success){
                resolve(res.result.map(i => {return {label: i.departName, value: i.id}}));
            } else {
                resolve([])
            }
        }).catch(e => {
            resolve([])
        });
    });
}